import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { palette } from '../../../../../../theme/palette';
const theme = palette('light');
export const ConfirmationDialog = ({ open, handleClose, handleSaveChanges }) => {
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: _jsxs(Box, { width: 717, sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '295px'
            }, children: [_jsx(Typography, { variant: 'h3', color: 'initial', mt: 2, children: "Changes have not been saved" }), _jsx(Typography, { variant: 'subtitle1', color: theme.black.dark, children: "Are you sure you don't want to save the changes you've made?" }), _jsxs(Box, { width: '386px', mt: 3, children: [_jsx(PrimaryButon, { mb: 1.5, onClick: handleSaveChanges, children: "Save changes" }), _jsx(Button, { onClick: handleClose, variant: 'text', size: 'large', sx: { fontWeight: 500 }, fullWidth: true, children: "Continue without saving" })] })] }) }));
};
